// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';
import { TailscaleHostAliasSchema } from './TailscaleHostAliasSchema'
import type { TailscaleHostAlias } from './TailscaleHostAliasSchema'
import { TailscaleSplitDnsSchema } from './TailscaleSplitDnsSchema'
import type { TailscaleSplitDns } from './TailscaleSplitDnsSchema'
import { TailscaleEgressProxySchema } from './TailscaleEgressProxySchema'
import type { TailscaleEgressProxy } from './TailscaleEgressProxySchema'
import { ApplicationWithRelationsSchema } from './ApplicationRelationsSchema'
import type { ApplicationWithRelations } from './ApplicationRelationsSchema'
import { ExternalNetworkWithRelationsSchema } from './ExternalNetworkRelationsSchema'
import type { ExternalNetworkWithRelations } from './ExternalNetworkRelationsSchema'
import { TailscaleNetworkSchema } from './TailscaleNetworkSchema';

/////////////////////////////////////////
// TAILSCALE NETWORK RELATION SCHEMA
/////////////////////////////////////////

export type TailscaleNetworkRelations = {
  hostAliases: TailscaleHostAlias[];
  splitDns?: TailscaleSplitDns | null;
  egressProxy?: TailscaleEgressProxy | null;
  resourceProxy?: TailscaleEgressProxy | null;
  application: ApplicationWithRelations[];
  externalNetworks: ExternalNetworkWithRelations[];
};

export type TailscaleNetworkWithRelations = z.infer<typeof TailscaleNetworkSchema> & TailscaleNetworkRelations

export const TailscaleNetworkWithRelationsSchema: z.ZodType<TailscaleNetworkWithRelations> = TailscaleNetworkSchema.merge(z.object({
  hostAliases: z.lazy(() => TailscaleHostAliasSchema).array(),
  splitDns: z.lazy(() => TailscaleSplitDnsSchema).nullable(),
  egressProxy: z.lazy(() => TailscaleEgressProxySchema).nullable(),
  resourceProxy: z.lazy(() => TailscaleEgressProxySchema).nullable(),
  application: z.lazy(() => ApplicationWithRelationsSchema).array(),
  externalNetworks: z.lazy(() => ExternalNetworkWithRelationsSchema).array(),
}))